module.exports = __webpack_public_path__ + "static/media/goal-website-img.8bbb635c.svg";